<div class="container mx-auto p-6">
  <div class="flex justify-between items-center mb-6">
    <div>
      <div class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400 mb-2">
        @if (variantOption?.product_name) {
          <span>{{ variantOption?.product_name }}</span>
          <span>›</span>
        }
        @if (variantOption?.variant_name) {
          <span>{{ variantOption?.variant_name }}</span>
          <span>›</span>
        }
        <span class="text-gray-600 dark:text-gray-300">{{ variantOption?.name }}</span>
      </div>
      <h1 class="text-2xl font-semibold text-gray-800 dark:text-white/90">
        Daily Prices
      </h1>
    </div>
    <app-button
      [label]="'Back'"
      [icon]="BackIcon"
      [style]="'secondary'"
      (click)="navigateBack()">
    </app-button>
  </div>

  <!-- Bulk Update Form -->
  <div class="mb-6">
    <app-daily-pricing-bulk-update
      [storeBulkDailyPrices]="storeBulkDailyPrices"
      [deleteBulkDailyPrices]="deleteBulkDailyPrices"
      (onSuccess)="onBulkUpdateSuccess()">
    </app-daily-pricing-bulk-update>
  </div>

  <!-- Calendar View with Overview -->
  <app-daily-pricing-calendar
    [getDailyPrices]="getDailyPrices"
    (onPriceClick)="onPriceClick($event)">
  </app-daily-pricing-calendar>
</div>
